const authToken = localStorage.getItem('token');

export const initialState = {
  token: authToken,
  getToken: null
}
